// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topbar {
    width: 100%; /* Ensure it takes the full width of the parent container */
    background-color: white;
    transition: margin-left 0.5s;
    box-shadow: 0 3px 5px -1px #0003, 0 6px 10px #00000024, 0 1px 18px #0000001f;
    position: fixed;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .top-bar {
    box-shadow: 0 3px 5px -1px #0003, 0 6px 10px #00000024, 0 1px 18px #0000001f;
    background-color: white;
    transition: margin-left 0.5s;
    /* border-bottom: 1px solid#EAA637; */
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }
  
  .rightBox {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-left: 22rem;
  }
  
  .TopNav {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    margin: 8px 40px;
  }
  
  .topRight {
    align-items: center;
  }
  .topbarwrapper {
    height: 100%;
    padding: 0px 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .logo {
    font-weight: bold;
    font-size: 20px;
    color: white;
    padding: 0px 5px;
    position: relative;
    top: -5px;
  }
  
  .topbarIconContainer {
    position: relative;
    cursor: pointer;
    margin-right: 10px;
    margin-left: 5px;
  }
  
  .topbarIconContainer a {
    text-decoration: none;
    color: white;
    font-size: large;
    align-items: center;
  }
  
  .topIconBadge {
    width: 15px;
    height: 15px;
    position: absolute;
    top: -5px;
    right: 0px;
    background-color: red;
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
  }
  
  .material-icons.md-light {
    color: rgba(255, 255, 255, 1);
  }
  
  .search-container {
    display: flex;
  }
  
  .search-wrapper {
    position: relative;
    display: flex;
  }
  
  .search-bar {
    padding: 6px 20px; /* Add padding to the left for the icon */
    border: 1px solid #ccc;
    border-radius: 20px;
    width: 25vw;
    outline: none;
    font-size: 14px;
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);
    transition: border-color 0.3s;
  }
  
  @media (max-width: 768px) {
    .search-bar {
      width: 40vw;
      margin-left: 1rem;
    }
    .rightBox {
      margin-left: 4rem;
    }
  }
  
  @media (max-width: 576px) {
    .search-bar {
      width: 50vw;
      margin-left: 0.5rem;
    }
    .icon {
      display: none;
    }
    .rightBox {
      margin: 0;
    }
  }
  
  .search-bar:focus {
    border-color: var(--primary-color);
  }
  
  .search-icon {
    position: absolute;
    right: 10px; /* Position the icon within the input field */
    top: 50%;
    transform: translateY(-50%);
    font-size: 15px;
    color: #ccc; /* Light color for the icon */
    pointer-events: none; /* Prevent clicking on the icon */
  }
  
  .button1 {
    background-color: white;
    color: #dc3545;
    border: 2px solid #dc3545;
    border-radius: 5px;
    padding: 4px 20px;
    font-weight: bold;
  }
  
  .button1:hover {
    background-color: #dc3545;
    font-weight: bold;
    color: white;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Topbar.css"],"names":[],"mappings":"AAAA;IACI,WAAW,EAAE,2DAA2D;IACxE,uBAAuB;IACvB,4BAA4B;IAC5B,4EAA4E;IAC5E,eAAe;IACf,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,4EAA4E;IAC5E,uBAAuB;IACvB,4BAA4B;IAC5B,qCAAqC;IACrC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;EAChC;EACA;IACE,iBAAiB;IACjB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,qBAAqB;IACrB,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,qBAAqB;IACrB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;EACjB;;EAEA;IACE,6BAA6B;EAC/B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,aAAa;EACf;;EAEA;IACE,iBAAiB,EAAE,yCAAyC;IAC5D,sBAAsB;IACtB,mBAAmB;IACnB,WAAW;IACX,aAAa;IACb,eAAe;IACf,8CAA8C;IAC9C,6BAA6B;EAC/B;;EAEA;IACE;MACE,WAAW;MACX,iBAAiB;IACnB;IACA;MACE,iBAAiB;IACnB;EACF;;EAEA;IACE;MACE,WAAW;MACX,mBAAmB;IACrB;IACA;MACE,aAAa;IACf;IACA;MACE,SAAS;IACX;EACF;;EAEA;IACE,kCAAkC;EACpC;;EAEA;IACE,kBAAkB;IAClB,WAAW,EAAE,6CAA6C;IAC1D,QAAQ;IACR,2BAA2B;IAC3B,eAAe;IACf,WAAW,EAAE,6BAA6B;IAC1C,oBAAoB,EAAE,iCAAiC;EACzD;;EAEA;IACE,uBAAuB;IACvB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,iBAAiB;EACnB;;EAEA;IACE,yBAAyB;IACzB,iBAAiB;IACjB,YAAY;EACd","sourcesContent":[".topbar {\n    width: 100%; /* Ensure it takes the full width of the parent container */\n    background-color: white;\n    transition: margin-left 0.5s;\n    box-shadow: 0 3px 5px -1px #0003, 0 6px 10px #00000024, 0 1px 18px #0000001f;\n    position: fixed;\n    z-index: 99;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .top-bar {\n    box-shadow: 0 3px 5px -1px #0003, 0 6px 10px #00000024, 0 1px 18px #0000001f;\n    background-color: white;\n    transition: margin-left 0.5s;\n    /* border-bottom: 1px solid#EAA637; */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n  }\n  \n  .rightBox {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-left: 22rem;\n  }\n  \n  .TopNav {\n    display: flex;\n    align-items: center;\n    justify-content: space-around;\n    width: 100%;\n    margin: 8px 40px;\n  }\n  \n  .topRight {\n    align-items: center;\n  }\n  .topbarwrapper {\n    height: 100%;\n    padding: 0px 20px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n  .logo {\n    font-weight: bold;\n    font-size: 20px;\n    color: white;\n    padding: 0px 5px;\n    position: relative;\n    top: -5px;\n  }\n  \n  .topbarIconContainer {\n    position: relative;\n    cursor: pointer;\n    margin-right: 10px;\n    margin-left: 5px;\n  }\n  \n  .topbarIconContainer a {\n    text-decoration: none;\n    color: white;\n    font-size: large;\n    align-items: center;\n  }\n  \n  .topIconBadge {\n    width: 15px;\n    height: 15px;\n    position: absolute;\n    top: -5px;\n    right: 0px;\n    background-color: red;\n    color: white;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 10px;\n  }\n  \n  .material-icons.md-light {\n    color: rgba(255, 255, 255, 1);\n  }\n  \n  .search-container {\n    display: flex;\n  }\n  \n  .search-wrapper {\n    position: relative;\n    display: flex;\n  }\n  \n  .search-bar {\n    padding: 6px 20px; /* Add padding to the left for the icon */\n    border: 1px solid #ccc;\n    border-radius: 20px;\n    width: 25vw;\n    outline: none;\n    font-size: 14px;\n    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.1);\n    transition: border-color 0.3s;\n  }\n  \n  @media (max-width: 768px) {\n    .search-bar {\n      width: 40vw;\n      margin-left: 1rem;\n    }\n    .rightBox {\n      margin-left: 4rem;\n    }\n  }\n  \n  @media (max-width: 576px) {\n    .search-bar {\n      width: 50vw;\n      margin-left: 0.5rem;\n    }\n    .icon {\n      display: none;\n    }\n    .rightBox {\n      margin: 0;\n    }\n  }\n  \n  .search-bar:focus {\n    border-color: var(--primary-color);\n  }\n  \n  .search-icon {\n    position: absolute;\n    right: 10px; /* Position the icon within the input field */\n    top: 50%;\n    transform: translateY(-50%);\n    font-size: 15px;\n    color: #ccc; /* Light color for the icon */\n    pointer-events: none; /* Prevent clicking on the icon */\n  }\n  \n  .button1 {\n    background-color: white;\n    color: #dc3545;\n    border: 2px solid #dc3545;\n    border-radius: 5px;\n    padding: 4px 20px;\n    font-weight: bold;\n  }\n  \n  .button1:hover {\n    background-color: #dc3545;\n    font-weight: bold;\n    color: white;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
